import darken from "./composed/darken.js";
// import lazyLoad from "./composed/lazy-load.js";
import swupInit from "./composed/swup.js";
import setupMenu from "./composed/setup-menu.js";
import scrollReveal from "./composed/scroll-reveal.js";
import splide from "./composed/splide.js";
import jarallax from "./composed/jarallax.js";
import glightbox from "./composed/glightbox.js";
import gridzy from "./composed/gridzy/gridzy.js";
import mixitup from "./composed/mixitup/mixitup.js";
import BackgroundSourceSet from "./composed/BGSrcset.js";
import plyr from "./composed/plyr.js";
import matchheight from "./composed/match-height.js";
import placeholderLabels from "./composed/placeholder-labels.js";
import headerscroll from "./composed/headerscroll.js";
import searchModal from "./composed/search-modal.js";
// import SlideNav from "./composed/slide-nav.js"; //quiet

document.addEventListener("DOMContentLoaded", firstLoadInit);

const bgss = new BackgroundSourceSet();
bgss.callonce = false;

const swup = swupInit(".gn-swup-wrapper");

function genericInit() {
    headerscroll.init();
    mixitup.init();
    darken.init();
    glightbox.init();
    gridzy.init();
    jarallax.init();
    plyr.init();
    splide.init();
    matchheight.init();
    placeholderLabels.init();
    scrollReveal.init();
    searchModal.init();

    const gnInitEvent = new Event("gnInit");
    document.dispatchEvent(gnInitEvent);

    //adding class to style search results page
    if (window.location.href.indexOf("&action_results=Go") > -1) {
        document.body.classList.add("SolidMenu");
    }

    if (window.location.href.indexOf("?filter=") > -1) {
        document.body.classList.add("Show_SmartPag");
    }

    // new SlideNav({ speed: 10 });

    bgss.init(".BGImage", function (a) {
        a.node.classList.add("loaded");
    });

    //lazyLoad();
}

/**
 * This script cleans up JS which is will no longer be needed on page change
 */
function cleanupScripts() {
    glightbox.cleanup();
    scrollReveal.cleanup();
    jarallax.cleanup();
    splide.cleanup();
    gridzy.cleanup();
    mixitup.cleanup();
    plyr.cleanup();
    scrollReveal.cleanup();
}

swup.on("willReplaceContent", cleanupScripts);

// init js when Swup has replaced page
swup.on("contentReplaced", pageSwapInit);

// run some things when links are clicked.
swup.on("clickLink", () => {
    setupMenu.closeMenus();
});

function pageSwapInit() {
    genericInit();
}

function firstLoadInit() {
    setupMenu.init();

    if (window.location.href.indexOf("&action_results=Go") > -1) {
        document.body.classList.remove("SolidMenu");
    }

    if (window.location.href.indexOf("?filter=") > -1) {
        document.body.classList.add("Show_SmartPag");
    }

    genericInit();
}
